import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';

const Wrapper = styled.View`
  flex: 1;
`;

const NarrowContent = ({ children }) => <Wrapper>{children}</Wrapper>;

NarrowContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NarrowContent;
